export const SAVE_LOCAL_STUDENT = "[STUDENT] SAVE_LOCAL_STUDENT_CONTINGENCY";
